import { Grid2,Typography } from "@mui/material"
export default function Version(){
    return (
        <>
            <Grid2
                container
                justifyContent="center"
                alignItems="center"
                sx={{ height: "30vh", flexDirection: "column" }}
                padding={5}
            >
                
                <Grid2 item>
                    <Typography
                        variant="h4"
                        sx={{ color: "#000000", fontFamily: "Inter500", textAlign: "center" }}
                    >
                        Version - 0.0.2
                    </Typography>
                </Grid2>

                
                <Grid2
                    item
                    sx={{
                        
                        mt: 2,
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{ color: "#000000", fontFamily: "Inter400" }}
                    >
                        0.0.1 - Adjusted the mobile capture height and improved alignment across all components.
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{ color: "#000000", fontFamily: "Inter400" }}
                    >
                        0.0.2 - Adjusted Signature lenght and Retake button alignment.
                    </Typography>
                </Grid2>
            </Grid2>

        </>
    )
}